import React from "react";

import './RelationWarning.scss' ;

const RelationWarning = ({ connections }) =>
{
    const getAdultNotes = ( contacts ) =>
    {
        const usersWithNotes = contacts.filter((rec) => {
            return rec.relation_notes !== null ;
        },[] );

        const userDivs = usersWithNotes.map((rec, idx) => {
            return (
                <div className='relation-warning-div' key={idx}>
                    <div>{ 'The following notes were recorded against ' + ' ' + rec.connection_firstname} {rec.connection_surname}</div>
                    <div className='note-text'>{rec.relation_notes}</div>
                </div>
            )
        });

        return userDivs ;
    }

    return (
        getAdultNotes( connections )
    )
}

export default RelationWarning;
